module.exports = __webpack_public_path__ + "img/joy_stick_bottom.85220e6c.png";